/**
 * USDT提款
 * moss
 */
import { connect } from "react-redux";
import { Fragment } from 'react'
import "./bindDigitalWallet.scss";


class BindDigitalWallet extends React.Component {
    constructor() {
        super();
        this.state = {
            showBindWindow:false,
            showCheckSecPwd:true,
            hasDigitalWallet:false,
            submitAddType:'',
            reBindId:'',
            checkOrModify:'check',
            digitalWalletList:[],
            bindStepIndex:1,
            checkcode:'',
            bindAddValue:'',
            bindSelectId:'',
            bindSelectName:'',
            coinTypeList:[],
            checklast_token:0,
            hasGooglePwd:false
        };
    }
    componentWillMount() {
        this.props.$$USER.getCoinTypeList((res=>{
            if (res.status == 10000) {
                this.setState({
                    coinTypeList:res.data.coinType,
                    hasGooglePwd:res.data.is_enable_two_fa
                })
            }
        }))
    }

    componentDidMount() {
        // this.props.$$USER.getCoinTypeList((res=>{
        //     if (res.status == 10000) {
        //         this.setState({
        //             coinTypeList:res.data.coinType,
        //             hasGooglePwg:res.data.is_enable_two_fa
        //         })
        //     }
        // }))
    }
    reset= () =>{
        this.refs.secPwd.value = '';
    }
    submit= () =>{
        const code = this.state.hasGooglePwd ? this.refs.GooglePwd.value : null
        const password = this.refs.secPwd.value
        let nextcon = "user", nextact = "bindsequestion";
        if(password == ''){
            return this.props.$$BASE.openAlert('请enter the withdrawal password!')
        }
        if(code == null && this.state.hasGooglePwd){
            return this.props.$$BASE.openAlert('请输入谷歌验证码!')
        }
        this.props.$$USER.checkSecurityPass(nextcon, nextact, password, (e) => {
            this.setState({
                checkcode:e.msg.checkcode,
            })
            if(e.status == 1){
                this.props.$$USER.getWalletList(e.msg.checkcode,(res)=>{
                    if (res.status == 10000) {
                        this.setState({
                            showBindWindow:true,
                            showCheckSecPwd:false
                        })
                        if (res.data.addresses.length > 0) {
                            this.setState({
                                hasDigitalWallet:true,
                                digitalWalletList:res.data.addresses
                            })
                        }
                    }

                })

            }
        },code);
    }

     //返回验证密码
     goCheckPwd=(message)=>{
        this.setState({
            showCheckSecPwd:true,
            showBindWindow:false
        })
        this.refs.secPwd.value = ''
        this.props.$$BASE.openAlert(message)
    }

    submitAdd=()=>{
        let address = this.refs.address.value
        if(this.state.submitAddType == 'add') {
            this.props.$$USER.checkLastBind(address,(res)=>{
                if (res.status == 10000) {
                    this.setState({
                        hasDigitalWallet:false,
                        checklast_token:res.data.checklast_token
                    })
                }
            })
        }
        if (this.state.submitAddType == 'lock' && this.state.checkOrModify == 'check') {
            this.props.$$USER.lockWallet([this.state.checkcode,address],(res)=>{
                if (res.status == 10000) {
                    this.props.$$BASE.openAlert('钱包已锁定!')
                }
                if(res.status == 30713){
                    this.goCheckPwd(res.message)
                }
            })
        }
        if (this.state.submitAddType == 'reBind'  && this.state.checkOrModify == 'check') {
            this.props.$$USER.checkReBind([this.state.checkcode,address,this.state.reBindId],(res)=>{
                if (res.status == 10000) {
                    this.setState({
                        reBind_token:res.data.rebinding_token,
                        checkOrModify:'modify'
                    })
                    this.refs.address.value = ''
                }
                if(res.status == 30713){
                    this.goCheckPwd(res.message)
                }
            })
        }
        if (this.state.submitAddType == 'reBind' && this.state.checkOrModify == 'modify') {
            this.props.$$USER.modifyWalletAddress([this.state.checkcode,address,this.state.reBindId,this.state.reBind_token],(res)=>{
                if (res.status == 10000) {
                    this.props.$$BASE.openAlert('新钱包已绑定完成!')
                    this.refs.address.value = ''
                }
                if(res.status == 30713){
                    this.goCheckPwd(res.message)
                }
            })
        }

    }
    comeBack=()=>{
        this.refs.myWalletList.style.display = 'block'
        this.refs.submitAddressFrom.style.display = 'none'
        this.setState({
            checkOrModify:'check'
        })
    }
    handleSubmitAddFrom=(type,id)=>{
        this.refs.myWalletList.style.display = 'none'
        this.refs.submitAddressFrom.style.display = 'block'
        this.setState({
            submitAddType:type
        })
        if (id) {
            this.setState({
                reBindId:id
            })
        }
    }
    checkBindAdd=()=>{
        let inputValue1 = this.refs.bindAdd1.value
        let inputValue2 = this.refs.bindAdd2.value
        let bindSelectId = this.refs.bindSelect.value
        let bindSelectName = this.state.coinTypeList.filter(obj=> obj.id == bindSelectId)[0].currency_code

        if (inputValue1 != inputValue2 || inputValue1 == '' ||inputValue2 == '' ){
            return this.props.$$BASE.openAlert('请检查您输入的提款地址是否有误!')
        }
        this.setState({
            bindAddValue:inputValue1,
            bindSelectId:bindSelectId,
            bindSelectName:bindSelectName,
            bindStepIndex:2,
        })
    }
    bindAdd=()=>{
        this.props.$$USER.bindNewWallet([this.state.checkcode,this.state.bindAddValue,this.state.bindSelectId,this.state.checklast_token],(res)=>{
            if (res.status == 10000) {
                this.setState({
                    bindStepIndex:3
                })
            }else {
                if(res.status == 30713){
                    return  this.goCheckPwd(res.message)
                }
                this.setState({
                    bindStepIndex:1
                })
            }
        })
    }
    bindWindowComeBack=()=>{
        if (this.state.digitalWalletList.length == 0) {
            return
        }
        this.setState({
            hasDigitalWallet:true
        })
    }
    render() {
        const __user = this.props.__USER.toJS();
        const info = __user.info;
        const hasGooglePwd = this.state.hasGooglePwd
        return (
            <Fragment>
                <div className="report-modal-header modal-title">
                    绑定数字钱包
                </div>
                <div className="check-sec-pwd" style={{display:(this.state.showCheckSecPwd) ? 'block' : 'none'}}>
                    <div className="value-box">
                        <span className='input-label'>enter the withdrawal password：</span>
                        <span className="value">
                            <input type="password" ref='secPwd' minLength="6" maxLength="16" /> <br/>
                        </span>
                    </div>
                    {
                        hasGooglePwd &&
                        <div className="value-box">
                            <span className='input-label'>输入谷歌验证码：</span>
                            <span className="value">
                                <input type="password" ref='GooglePwd' minLength="6" maxLength="16" /> <br/>
                            </span>
                        </div>
                    }
                    <div className="actions">
                        <button onClick={this.reset} className='big'>reset</button>
                        <button onClick={this.submit} className="big submit">确认</button>
                    </div>
                </div>
                <div className="bind-content" style={{display:(this.state.showBindWindow) ? 'block' : 'none'}}>
                    <div className="never-bind" style={{display:this.state.hasDigitalWallet ? 'none' : 'block'}}>
                        <div className="bind-step-1" style={{display:this.state.bindStepIndex == 1 ? 'block' : 'none'}}>
                            <ul className="submit-bind-box">
                                <li>提示：<i>*</i>为必填信息</li>
                                <li>
                                    <span><i>* </i>货币类型：</span>
                                    <select name="" id="" ref="bindSelect">
                                        {
                                            this.state.coinTypeList.map(item => <option key={item.id} value={item.id} >{item.currency_code}</option>)
                                        }
                                    </select>
                                </li>
                                <li>
                                    <span><i>* </i>提现钱包地址：</span>
                                    <input type="text" ref="bindAdd1"/>
                                    <i> 请输入您的钱包地址</i>
                                </li>
                                <li>
                                    <span><i>* </i>确认钱包地址：</span>
                                    <input type="text" onPaste={(e)=>e.preventDefault()} ref="bindAdd2"/>
                                    <i> 只能手动输入不能粘贴</i>
                                </li>
                            </ul>
                            <p className="point-text">温馨提示：请您务必核对钱包地址准确无误，如因地址错误导致提款不到账，平台不承担任何损失。</p>
                            <div className="actions">
                                <button onClick={this.checkBindAdd} className='big submit'>下一步</button>
                                <button onClick={this.bindWindowComeBack} className="big">返回</button>
                            </div>
                        </div>
                        <div className="bind-step-2" style={{display:this.state.bindStepIndex == 2 ? 'block' : 'none'}}>
                            <ul>
                                <li>
                                    <span>数字币种：</span>
                                    <span>{this.state.bindSelectName}</span>
                                </li>
                                <li>
                                    <span>提现钱包地址：</span>
                                    <span>{this.state.bindAddValue}</span>
                                </li>
                            </ul>
                            <div className="actions">
                                <button onClick={this.bindAdd} className='big submit'>提交</button>
                                <button onClick={()=>this.setState({bindStepIndex:1})} className="big">返回</button>
                            </div>
                        </div>
                        <div className="bind-step-3" style={{display:this.state.bindStepIndex == 3 ? 'block' : 'none'}}>
                            <div>
                                <img src="" alt=""/>
                            </div>
                            <p>
                                绑定成功！温馨提示：新绑定的卡需要8小时后才能体现。
                            </p>
                        </div>
                    </div>
                    <div className="already-bind" style={{display:this.state.hasDigitalWallet ? 'block' : 'none'}}>
                        <div className="table-box" ref="myWalletList">
                            <ul className="table-header clearfix">
                                <li className="fl width-10p">用户名</li>
                                <li className="fl width-20p">数字货币</li>
                                <li className="fl width-30p">数字钱包地址</li>
                                <li className="fl width-30p">绑定时间</li>
                                <li className="fl width-10p">操作</li>
                            </ul>
                            <ul className="table-body">
                                {
                                    this.state.digitalWalletList.map(item =>
                                        <li key={item.id}>
                                            <span className="width-10p">{info.username}</span>
                                            <span className="width-20p">{item.bank_name}</span>
                                            <span className="width-30p">{item.account}</span>
                                            <span className="width-30p">{item.atime}</span>
                                            <span style={{color:'#785ffb',cursor:'pointer'}} className="width-10p" onClick={()=>this.handleSubmitAddFrom('reBind',item.id)}>重新绑定</span>
                                        </li>)
                                }
                            </ul>
                            <div className="bind-btn-box-1">
                                <p onClick={()=>this.handleSubmitAddFrom('add')}>增加绑定</p>
                                <p onClick={()=>this.handleSubmitAddFrom('lock')}>锁定钱包</p>
                            </div>
                            <div className="line usdt" style={{display:this.state.stepIndex == 3? 'none':'block' }}/>
                            <div className="text-box">
                                <p>一个账户最多绑定5个数字钱包地址</p>
                                <p>钱包锁定可以增强账户安全，推荐锁定（如：账户被他人盗用后，由于锁定的限制，您账户的资金不会被他人提款）</p>
                                <p>钱包锁定后，不能增加新的钱包地址绑定，自身不能解绑和解锁钱包，联系您的上级申请解锁</p>
                            </div>
                        </div>
                        <div className="submit-address-form" ref="submitAddressFrom">
                            <p className="title-text">
                                {
                                    this.state.submitAddType == 'lock' ? '注意：在线客服不提供账户数字钱包解锁业务，若要解锁请向上级代理申请。' : '注：增加绑定数字钱包需提供最近一次绑定的地址信息！'
                                }
                            </p>
                            <div className="input-value-box">
                                <span>数字钱包地址</span>
                                <input ref="address" type="text"/>
                                <span>
                                    {
                                        this.state.checkOrModify == 'check' ? ' 请输入最近一次绑定数字钱包地址。' : ' 请输入最新绑定数字钱包地址。'
                                    }
                                </span>
                            </div>
                            <div className="actions">
                                <button className='big submit' onClick={this.submitAdd}>提交</button>
                                <button className="big" onClick={this.comeBack}>返回</button>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        __USER: state.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        $$BASE: bindActionCreators(baseAction, dispatch),
        $$USER: bindActionCreators(userAction, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BindDigitalWallet);
